import React from "react";
import StateTag from "Components/state-tag";
import { formatDate, sort } from "Utils";
import OperationsColumn from "./operations-column";
import { Table } from "antd";
import Highlighter from "react-highlight-words";

export default function RealEstatesTable({
  data,
  IsAuthorized,
  loading,
  filteredValue,
  onSetFilteredValue,
  onOperationExecuted,
  ...props
}) {
  const columns = [
    {
      title: "Kod",
      dataIndex: "code",
      width: 80,
      key: "code",
      sorter: (a, b) => {
        return a.code.substr(1) - b.code.substr(1);
      },
    },
    {
      title: "İsim",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={record.name}
          />
        );
      },
      sorter: (a, b) => sort(a.name, b.name),
      ellipsis: true,
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.description}
        />
      ),
      key: "description",
      sorter: (a, b) => sort(a.description, b.description),
      ellipsis: true,
    },
    {
      title: "Kayıt Türü",
      dataIndex: ["realEstateRecordType", "description"],
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.realEstateRecordType?.description || ""}
        />
      ),
      key: "description",
      sorter: (a, b) =>
        sort(
          a.realEstateRecordType?.description,
          b.realEstateRecordType?.description
        ),
      ellipsis: true,
    },
    {
      title: "Durumu",
      dataIndex: ["realEstateStatu", "description"],
      render: (text, record) => (
        <>
          <StateTag state={record.state} />
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={record.realEstateStatu?.description || ""}
          />
        </>
      ),
      key: "realEstateStatu",
      sorter: (a, b) =>
        sort(a.realEstateStatu?.description, b.realEstateStatu?.description),
      ellipsis: true,
    },
    {
      title: "Tapu Türü",
      dataIndex: "deed",
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={
            (record.deeds &&
              record.deeds.length > 0 &&
              record.deeds[0].type?.description) ||
            ""
          }
        />
      ),
      key: "deedType",
      sorter: (a, b) =>
        sort(
          (a.deeds && a.deeds.length > 0 && a.deeds[0].type?.description) || "",
          (b.deeds && b.deeds.length > 0 && b.deeds[0].type?.description) || ""
        ),
      ellipsis: true,
    },
    {
      title: "Malikler",
      dataIndex: "shareHolders",
      key: "shareHolders",
      ellipsis: true,
      render: (text, record) => {
        let maliks = record?.shareHolders
          .map(
            (element) =>
              `${element.shareHolder?.name || ""} ${
                element.shareHolder?.surname || ""
              } (${element.percentage}%)`
          )
          .join(",");

        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={maliks}
          />
        );
      },
    },
    {
      title: "Yaratma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => sort(a.createdAt, b.createdAt),
      ellipsis: true,
      render: (text, record) => {
        return formatDate(record.createdAt);
      },
    },
    {
      title: "İşlemler",
      width: 180,
      fixed: "right",
      dataIndex: "operation",
      render: (text, record) => (
        <OperationsColumn
          collapsed={false}
          record={record}
          onOperationExecuted={onOperationExecuted}
        />
      ),
    },
  ];

  return (
    <Table
      style={{ margin: "0 24px" }}
      rowKey={(row) => row.id}
      loading={loading}
      dataSource={data}
      columns={columns}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      pagination={{
        total: data.length,
        pageSize: 20,
        showSizeChanger: false,
        showTotal: (total, range) => {
          return `Toplam ${total} sonuçtan ${range.join(
            "-"
          )} arası gösteriliyor.`;
        },
      }}
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
